import Styles from './FacebookStoryPreview.module.scss'
import { FacebookIntegration } from 'api/clients/ExternalIntegrationsClient'
import cx from 'classnames'
import { ReactNode } from 'react'
import { Header } from './Header'
import { MediaObject } from 'types'
import { MediaRenderer } from '../components/MediaRenderer/MediaRenderer'
import { DesignChannel } from 'components/NewFileModal/Types'

interface FacebookStoryPreviewProps {
  integration?: FacebookIntegration
  mediaObject?: MediaObject
  showVideoControls?: boolean
  onEdit?: () => void
  containerClassName?: string
  customPreviewContent?: ReactNode
  isActive?: boolean
  isTransitioning?: boolean
  isGenerating?: boolean
  showHoverActionOverlay?: boolean
  almanacFileKey?: string
  onClose?: () => void
}

export const FacebookStoryPreview = ({
  integration,
  showVideoControls,
  onEdit,
  containerClassName,
  customPreviewContent,
  mediaObject,
  isActive = true,
  isTransitioning = false,
  isGenerating = false,
  showHoverActionOverlay = false,
  almanacFileKey,
  onClose,
}: FacebookStoryPreviewProps) => {
  return (
    <div className={cx(Styles.container, containerClassName)}>
      <Header integration={integration} onEdit={onEdit} />

      <div className={Styles.content}>
        {customPreviewContent && customPreviewContent}
        {!customPreviewContent && mediaObject && (
          <MediaRenderer
            channel={DesignChannel.FacebookStory}
            mediaObject={mediaObject}
            alt="Story content"
            className={Styles.storyImage}
            showHoverActionOverlay={showHoverActionOverlay}
            almanacFileKey={almanacFileKey}
            showVideoControls={showVideoControls}
            isActive={isActive}
            onClose={onClose}
            isGenerating={isGenerating}
          />
        )}
      </div>
    </div>
  )
}
